import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Star, CheckCircle, ThumbsUp } from "lucide-react";
import "../../CSS/NewOnboading/ThankYouPage.css";
import {
  pre_pay_payment,
  server_post_data,
} from "../../../ServiceConnection/serviceconnection";
import { handleError } from "../../../CommonJquery/CommonJquery";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
export default function ThankYouPage() {
  const [stars, setStars] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paymentId = queryParams.get("id");
  const cus_id = queryParams.get("cus_id");
  const sub_id = queryParams.get("sub_id");
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  useEffect(() => {
    const starsArray = [];
    for (let i = 0; i < 20; i++) {
      const size = Math.random() * 20 + 10;
      const left = Math.random() * 100;
      const animationDelay = Math.random() * 5;
      const animationDuration = Math.random() * 3 + 2;

      starsArray.push(
        <div
          key={i}
          className="star-animation"
          style={{
            left: `${left}%`,
            top: `${Math.random() * 100}%`,
            fontSize: `${size}px`,
            animationDelay: `${animationDelay}s`,
            animationDuration: `${animationDuration}s`,
          }}
        >
          <Star size={size} fill="currentColor" />
        </div>,
      );
    }
    setStars(starsArray);
  }, []);

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    let fd = new FormData();
    fd.append("flag", "2");
    fd.append("payment_id", paymentId ?? uuidv4());
    fd.append("cus_id", cus_id ?? uuidv4());
    fd.append("sub_id", sub_id ?? uuidv4());
    await server_post_data(pre_pay_payment, fd)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          setTimeout(() => {
            window.location.href = "/";
          }, 5000);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  useEffect(() => {
    master_data_get();
  }, []);
  return (
    <div className="thankYouPageDiv">
      <div className="thank-you-container">
        {/* Animated stars background */}
        {stars}

        {/* Orange decorative circles */}
        <div className="decorative-circle circle-top-left"></div>
        <div className="decorative-circle circle-bottom-right"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <div className="thank-you-card">
                <div className="text-center">
                  <div className="icon-container mb-4">
                    <div className="check-circle">
                      <CheckCircle size={40} className="text-white" />
                    </div>
                  </div>

                  <h1 className="thank-you-title mb-2">Thank You!</h1>
                  <p className="thank-you-subtitle mb-4">
                    Payment successful! A confirmation email has been sent to
                    you.
                  </p>

                  <div className="star-rating mb-4 mx-auto">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Star
                        key={star}
                        size={30}
                        className="star-icon"
                        fill="yellow"
                      />
                    ))}
                  </div>

                  <p
                    className="feedback-text"
                    style={{ marginBottom: "20px", marginTop: "20px" }}
                  >
                    Your WowReviews subscription is now active <br />— let’s
                    start collecting 5-star reviews.
                  </p>

                  <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
                    <Link
                      to="/"
                      className="btn btn-outline-primary home-button"
                    >
                      <ThumbsUp size={18} fill="yellow" className="me-2" />
                      Home Page
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
